/**
 * RegionContext
 *
 * La URL es la ÚNICA fuente de verdad para la región.
 * Parsea el pathname para detectar /mx/* o /us/*.
 *
 * Expone: { region, currency, symbol, flag, label, other, switchRegion }
 */
import React, { createContext, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const REGION_META = {
  mx: { currency: 'mxn', symbol: 'MX$', flagCode: 'mx', flag: 'mx', label: 'México',        other: 'us' },
  us: { currency: 'usd', symbol: '$',    flagCode: 'us', flag: 'us', label: 'United States', other: 'mx' },
};

const RegionContext = createContext(undefined);

export function RegionProvider({ children }) {
  const location = useLocation();
  const navigate  = useNavigate();
  const [showRegionHint, setShowRegionHint] = useState(false);

  // Extrae región del pathname: /mx/... → 'mx', /us/... → 'us', fallback 'mx'
  const match  = location.pathname.match(/^\/(mx|us)(\/|$)/);
  const region = match ? match[1] : 'mx';
  const meta   = REGION_META[region];

  function switchRegion() {
    const newRegion = meta.other;
    const newPath   = match
      ? location.pathname.replace(new RegExp(`^/${region}`), `/${newRegion}`)
      : `/${newRegion}`;
    navigate(newPath + location.search, { replace: true });
  }

  return (
    <RegionContext.Provider value={{ region, ...meta, switchRegion, showRegionHint, setShowRegionHint }}>
      {children}
    </RegionContext.Provider>
  );
}

export function useRegion() {
  const ctx = useContext(RegionContext);
  if (!ctx) throw new Error('useRegion must be used inside RegionProvider');
  return ctx;
}
